import { mergeProps as _mergeProps, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import MgUpload from './mg-upload';
export default {
  __name: 'mg-upload-file',
  props: {
    ttl: {
      type: Boolean,
      default: true
    },
    // true上传为临时文件，后面需要commitFiles提交，否则将系统将自动删除
    dir: {
      type: String,
      default: ''
    },
    // 上传的目录
    cate: {
      type: String,
      default: ''
    },
    // 上传的分类
    multiple: {
      type: Boolean,
      default: true
    },
    showProgress: {
      type: Boolean,
      default: true
    },
    limitSize: {
      type: Number,
      default: 10
    },
    // 大小限制,单位M
    limitCount: {
      type: Number,
      default: 1
    },
    paramName: {
      type: String,
      default: 'file'
    },
    // 上传参数名
    buttonText: {
      type: String,
      default: '上传文件'
    },
    buttonIcon: {
      type: String,
      default: 'vxe-icon-upload'
    },
    autoSubmit: {
      type: Boolean,
      default: true
    },
    imageTypes: {
      type: Array,
      default: () => ['jpg', 'jpeg', 'png', 'gif', 'webp']
    },
    fileTypes: {
      type: Array,
      default: () => ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf']
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    showList: {
      type: Boolean,
      default: true
    },
    typeField: {
      type: String,
      default: 'ext'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    urlField: {
      type: String,
      default: 'url'
    },
    sizeField: {
      type: String,
      default: 'size'
    },
    autoHiddenButton: {
      type: Boolean,
      default: true
    },
    showUploadButton: {
      type: Boolean,
      default: true
    },
    showRemoveButton: {
      type: Boolean,
      default: true
    },
    showDownloadButton: {
      type: Boolean,
      default: true
    },
    showPreview: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(MgUpload), _mergeProps({
        mode: "file"
      }, {
        ...props,
        ..._ctx.$attrs
      }), _createSlots({
        _: 2
      }, [_renderList(Object.keys(_ctx.$slots), key => {
        return {
          name: key,
          fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
            key: key
          }, scope))])
        };
      })]), 1040);
    };
  }
};